export const LINKS: { label: string; page: number }[] = [
    { label: "Home", page: 0 },
    { label: "Key Projects", page: 1 },
    { label: "About", page: 2 },
    { label: "Integrations", page: 4 },
    { label: "Contact", page: 7 },
];